import type { LoaderFunctionArgs } from "react-router-dom";
import { protectedLoader } from "./protected-loader";
import type { RoleSlug } from "./roles";
import type { DashboardLoaderResult } from "./types";

/**
 * Loader for the `/app/dashboard` route node.
 *
 * Behaviour:
 * - Composes `protectedLoader` to handle auth + role check.
 * - Reads role.slug and returns it alongside `user` so widgets can gate
 *   their first paint via `useLoaderData()` (no flicker — PITFALLS R1).
 *
 * Loop guard: This loader does NOT redirect. Per ADR 0002 / D-02, scanners
 * deep-linking to `/app/dashboard` see role-trimmed promo tiles, not a redirect.
 * Adding a redirect here would conflict with the navigation-intent contract.
 */
export function dashboardLoader() {
  const inner = protectedLoader();
  return async (args: LoaderFunctionArgs): Promise<DashboardLoaderResult | Response> => {
    const result = await inner(args);
    if (result instanceof Response) return result;
    const roleSlug = (result.user.role?.slug ?? "") as RoleSlug;
    return { ...result, roleSlug };
  };
}
